export default __webpack_public_path__ + "static/media/emotionH.e0c08819.png";